
import Vue from 'vue'

import ICON_VISA from './../../../../../app/assets/images/web/common/payment/icon-visa.svg'
import ICON_MASTER from './../../../../../app/assets/images/web/common/payment/icon-master.svg'
// import ICON_GRAB from './../../../../../app/assets/images/web/common/payment/icon-grabpay.svg'
// import ICON_FPX from './../../../../../app/assets/images/web/common/payment/icon-fpx.svg'
// import ICON_UNION_PAY from './../../../../../app/assets/images/web/common/payment/icon-unionpay.svg'

import ICON_GDEX from './../../../../../app/assets/images/web/common/logistics/icon-gdex.svg'
import ICON_FLASH from './../../../../../app/assets/images/web/common/logistics/icon-flash.svg'
import ICON_LALA_MOVE from './../../../../../app/assets/images/web/common/logistics/icon-lalamove.svg'
import ICON_PGEON from './../../../../../app/assets/images/web/common/logistics/icon-pgeon.svg'
import ICON_CITY_LINK from './../../../../../app/assets/images/web/common/logistics/icon-citylink.svg'
import ICON_LINKEDIN from './../../../../../app/assets/images/web/common/icon-linkedin.svg'
import ICON_FACEBOOK from './../../../../../app/assets/images/web/common/icon-facebook.svg'
import ICON_INSTAGRAM from './../../../../../app/assets/images/web/common/icon-instagram.svg'

import { getRegion } from '@/utils/common'

interface MenuItem {
  header: string;
  media?: boolean;
  items?: LinkItem[];
}
interface LinkItem {
  title: string;
  link?: string;
  image?: string;
  items?: LinkItem[];
  external?: boolean;
}

export default Vue.extend({
  data(): {
    custaRegInfo: string
  } {
    return {
      custaRegInfo: 'CUSTA SDN. BHD. [Company Registration No. 202301029516 (1523439-U)] '
    }
  },
  computed: {
    copyRightYear(): number {
      return new Date().getFullYear()
    },
    isRegionMY(): boolean {
      return getRegion()?.region == 'my'
    },
    categoriesItems(): LinkItem[] {
      return [
        {
          title: 'TOTE BAGS', link: 'tote-bags-printing/',
          items: [
            { title: 'Canvas Bags', link: 'canvas-bags/' },
            { title: 'Cotton Bags', link: 'cotton-bags/' },
            { title: 'Drawstring Bags', link: 'drawstring-bags/' },
            { title: 'Jute Bags', link: 'jute-bags/' },
            { title: 'Non-Woven Bags', link: 'non-woven-bags/' },
            { title: 'Polyester Bags', link: 'polyester-bags/' },
            { title: 'PP-Woven Bags', link: 'pp-woven-bags' }
          ]
        },
        {
          title: 'T-SHIRTS', link: 't-shirts-printing/',
          items: [
            { title: 'Cotton T-shirts', link: 'cotton-t-shirts/' },
            { title: 'Kids T-shirts', link: 'kids-t-shirts/' },
            { title: 'Long-Sleeve T-shirts', link: 'long-sleeve-t-shirts/' },
            { title: 'Oversize Cotton T-shirts', link: 'oversize-cotton-t-shirt/' },
            { title: 'Quick Dry T-shirts', link: 'quickdry-t-shirts/' },
            { title: 'Sleeveless T-shirts', link: 'sleeveless-t-shirts/' }
          ]
        },
        {
          title: 'POLO SHIRTS', link: 'polo-shirts-printing/',
          items: [
            { title: 'Honeycomb Polo', link: 'honeycomb-polo/' },
            { title: 'Other Fabric Polo', link: 'other-fabric-polo/' },
            { title: 'Quick Dry Polo', link: 'quick-dry-polo/' }
          ]
        },
        {
          title: 'CLOTHES', link: 'clothes-printing/',
          items: [
            { title: 'Apron', link: 'apron/' },
            { title: 'Cap & Hat', link: 'cap-and-hat/' },
            { title: 'Corporate Uniform', link: 'corporate-uniform/' },
            { title: 'Sweatshirt Hoodie Jacket', link: 'sweatshirt-hoodie-jacket/' },
            { title: 'Work Clothes', link: 'work-clothes/' }
          ]
        },
        {
          title: 'DRINKWARE', link: 'drinkware-printing/',
          items: [
            { title: 'Bottles', link: 'bottles/' },
            { title: 'Mugs', link: 'mugs/' },
            { title: 'Tumbler', link: 'tumbler-bottle/' }
          ]
        },
        {
          title: 'LANYARD', link: 'lanyard-printing/',
          items: [
            { title: 'Lanyard 15mm', link: 'lanyard-15mm/' },
            { title: 'Lanyard 20mm', link: 'lanyard-20mm/' },
            { title: 'Lanyard 25mm', link: 'lanyard-25mm/' },
            { title: 'Lanyard 30mm', link: 'lanyard-30mm/' }
          ]
        },
        {
          title: 'UMBRELLAS', link: 'umbrella-printing/',
          items: [
            { title: 'Straight Umbrellas', link: 'straight-umbrellas/' },
            { title: 'Fordable Umbrellas', link: 'fordable-umbrellas/' },
            { title: 'Golf  Umbrellas', link: 'golf-umbrellas/' }
          ]
        }
      ]
    },
    helpItems(): LinkItem[] {
      return [
        { title: 'Privacy Policy', link: 'https://support.custa.com/en/knowledge-base/custa-privacy-policy', external: true },
        { title: 'Refund Policy', link: 'https://support.custa.com/en/knowledge-base/custa-refund-program-policy', external: true },
        { title: 'Terms & Conditions', link: 'https://support.custa.com/en/knowledge-base/custa-terms-conditions', external: true },
        { title: 'Contact Us', link: '/contact' }
      ]
    },
    paymentItems(): LinkItem[] {
      return [
        { title: 'custa-payment-visa', image: ICON_VISA },
        { title: 'custa-payment-master', image: ICON_MASTER }
        // { title: 'custa-payment-grab', link: '/', image: ICON_GRAB },
        // { title: 'custa-payment-fpx', link: '/', image: ICON_FPX },
        // { title: 'custa-payment-union-pay', link: '/', image: ICON_UNION_PAY }
      ]
    },
    socialItems(): LinkItem[] {
      return [
        { title: 'custa instagram page', link: 'https://www.instagram.com/custa_my', image: ICON_INSTAGRAM },
        { title: 'custa facebook page', link: 'https://www.facebook.com/custagroup', image: ICON_FACEBOOK },
        { title: 'custa linkedin page', link: 'https://www.linkedin.com/company/custa-group/about/', image: ICON_LINKEDIN }
      ]
    },
    paymentSocial(): MenuItem[] {
      return [
        { header: 'Payment', items: this.paymentItems, media: true },
        { header: 'Follow us', items: this.socialItems, media: true }
      ]
    },
    companyItems(): LinkItem[] {
      return [
        { title: 'About Us', link: '/' },
        { title: 'CUSTA Careers', link: '/' },
        { title: 'CUSTA Policy', link: '/' }
      ]
    },
    logisticItems(): LinkItem[] {
      return [
        { title: 'custa-logistics-gdex', link: '/', image: ICON_GDEX },
        { title: 'custa-logistics-flash', link: '/', image: ICON_FLASH },
        { title: 'custa-logistics-lala-move', link: '/', image: ICON_LALA_MOVE },
        { title: 'custa-logistics-pgeon', link: '/', image: ICON_PGEON },
        { title: 'custa-logistics-city-link', link: '/', image: ICON_CITY_LINK }
      ]
    },
    menuItems(): MenuItem[] {
      return [
        // { header: 'Company', items: this.companyItems },
        { header: 'Help Center', items: this.helpItems }
        // { header: 'Logistics', items: this.logisticItems}
      ]
    }
  }
})
